import React from "react";

import AppBar from "@mui/material/AppBar";
import kantarLogo from "./Assets/kantar-logo-white.png";
import { useTheme } from "@mui/material/styles";
import styled from "@emotion/styled";
import LogoutIcon from "@mui/icons-material/Logout";
import { logoutMSAL } from "auth/MsalAuth";

function Navigation({ accessDenied }) {
  const theme = useTheme();
  return (
    <AppBar position="static" sx={{ backgroundColor: theme.palette.blackish.main }}>
      <PaddedDiv compact={accessDenied}>
        <img src={kantarLogo} alt="The Kantar Logo" style={{ height: "2rem" }} />
        <LogOut onClick={() => logoutMSAL()}>
          {" "}
          <LogoutIcon sx={{ height: "1.25rem", width: "1.25rem" }} />{" "}
          <div style={{ position: "relative", top: "0.0625rem" }}>Logout</div>
        </LogOut>
      </PaddedDiv>
    </AppBar>
  );
}

const PaddedDiv = styled.div`
  padding: ${(props) => (props.compact ? "3vh min(8vw, 5.625rem)" : "min(8vw, 5.625rem)")};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LogOut = styled.div`
  display: inline-flex;
  padding: 0.3125rem 0.625rem;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  background: #fff;
  color: #000;
  font-size: 1.125rem;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export default Navigation;
